import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface CalendarChartProps {
  data: Array<[string, number]>;
  height?: number | string;
  loading?: boolean;
}

export function CalendarChart({ data, height, loading }: CalendarChartProps) {
  const maxVal = Math.max(...data.map((d) => d[1]), 1);
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    visualMap: { min: 0, max: maxVal, orient: 'horizontal', left: 'center', bottom: 0, calculable: true },
    calendar: { top: 20, left: 20, right: 20, cellSize: ['auto', 15], range: '2025', itemStyle: { borderWidth: 1 }, dayLabel: { firstDay: 1 }, monthLabel: { show: true }, yearLabel: { show: true } },
    series: [{ type: 'heatmap', coordinateSystem: 'calendar', data }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
